import { Outlet } from 'react-router-dom';
import { AuthProvider } from '../../common/context';
import Content from './ui/partials/Content';
import Footer from './ui/partials/Footer';
import React from 'react';

const Layout: React.FC = () => (
  <AuthProvider>
    <div data-testid="layout" className="h-screen w-screen flex bg-primary">
      <Content>
        <Outlet />
      </Content>
      <Footer />
    </div>
  </AuthProvider>
);

export default Layout;
